import axios from 'axios';

export const planApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/stk-plans`,
    headers: {
        'Content-Type': 'application/json'
    }
})